export const winstonpos = {
  seo: {
    title: 'WinstonPOS integratie | Bistroo',
    description: 'Koppel WinstonPOS aan je Bistroo-webshop. Online bestellingen komen automatisch als kassatickets binnen, snel instellen, vlekkeloos werken.',
  },
  hero: {
    category: 'Kassasysteem',
    description: 'Online bestellingen via Bistroo komen direct als kassatickets binnen in WinstonPOS, volledig automatisch, zonder tussenstappen.',
  },
  about: {
    title: 'Wat doet WinstonPOS?',
    p1: 'WinstonPOS is een modern, cloud-gebaseerd kassasysteem dat speciaal is ontwikkeld voor de Nederlandse horeca. Het biedt een intuïtief touchscreen-interface, voorraadbeheer en uitgebreide rapportages, allemaal in één platform dat meegroeit met je zaak.',
    p2: 'Dankzij de directe koppeling met Bistroo verwerkt WinstonPOS online bestellingen net zo snel als tafeltransacties aan de toonbank. Productopties, allergenen, afhaaltijden, alles wordt meegestuurd naar het kassascherm en de keukenprinter.',
    benefits_title: 'Wat levert de koppeling op?',
    benefits: [
      'Automatisch kassaticket bij elke online bestelling',
      'Productopties en speciale wensen doorgegeven',
      'Afhaaltijd zichtbaar op keukenprinter',
      'Gecombineerde omzetrapportage online en offline',
      'Ondersteuning voor meerdere vestigingen',
    ],
  },
  wordcloud_title: 'WinstonPOS in een oogopslag',
  wordcloud: ['Touchscreen kassa', 'Cloud POS', 'Kassascherm', 'Keukenprinter', 'Tafelbeheer', 'Dagrapport', 'Meerdere printers', 'Bonafdruk', 'Split bill', 'Personeelsinlog', 'Locatiebeheer', 'API-koppeling', 'Orderverwerking', 'Horecasoftware', 'Omzetinzicht'],
  usp: {
    heading: 'Waarom Bistroo koppelen aan WinstonPOS?',
    items: [
      { icon: 'bi-receipt', title: 'Direct kassaticket', text: 'Elke online bestelling verschijnt automatisch op het kassascherm van WinstonPOS. Jouw team hoeft niets over te typen.' },
      { icon: 'bi-printer-fill', title: 'Slimme printerroutering', text: 'Warme gerechten naar de keuken, dranken naar de bar. WinstonPOS routeert elk artikel naar de juiste printer.' },
      { icon: 'bi-graph-up', title: 'Gecombineerde omzet', text: 'Online bestellingen en kassa-transacties komen samen in één WinstonPOS-rapportage. Volledig overzicht zonder handmatig samenvoegen.' },
      { icon: 'bi-emoji-smile-fill', title: 'Minder stress op drukke momenten', text: 'Tijdens de lunchpiek verwerkt de koppeling automatisch alle kanalen. Jouw team focust op bereiden en serveren.' },
      { icon: 'bi-list-check', title: 'Allergenen & opties correct', text: 'Productopties, varianten en allergeneninstructies worden foutloos doorgegeven aan het kassascherm van WinstonPOS. Geen misverstanden, geen klachten.' },
      { icon: 'bi-building', title: 'Schaalbaar naar meerdere vestigingen', text: 'WinstonPOS en Bistroo ondersteunen meerdere locaties. Beheer alle vestigingen vanuit één Bistroo Merchant Portal en schakel eenvoudig per locatie.' },
    ],
  },
  setup: {
    heading: 'Zo koppel je WinstonPOS aan Bistroo',
    steps: [
      'Activeer de Bistroo-module in je WinstonPOS-beheerpaneel.',
      'Kopieer je WinstonPOS-locatiecode en API-sleutel uit de instellingen.',
      'Ga in Bistroo Merchant Portal naar Integraties → WinstonPOS.',
      'Voer de locatiecode en API-sleutel in en bevestig de verbinding.',
      'Doe een testbestelling en controleer of het kassaticket correct aankomt.',
    ],
  },
  faq: {
    items: [
      { q: 'Welke WinstonPOS-versie ondersteunt de koppeling?', a: 'De Bistroo-koppeling is compatibel met WinstonPOS versie 3.0 en hoger. Neem contact op met WinstonPOS-support als je niet zeker weet welke versie je gebruikt.' },
      { q: 'Kunnen meerdere vestigingen worden gekoppeld?', a: 'Ja. Je kunt elke Bistroo-locatie koppelen aan het bijbehorende WinstonPOS-verkooppunt. Beheer alles centraal in je Bistroo-dashboard.' },
      { q: 'Worden speciale wensen en productopties doorgegeven?', a: 'Absoluut. Alle opmerkingen, varianten en allergeneninformatie die klanten meesturen worden als instructies op het kassaticket weergegeven.' },
      { q: 'Hoe stel ik producttijden of timeblocks in?', a: 'Tijdvakken voor afhalen en bezorgen stel je in via het Bistroo Merchant Portal. De geplande tijd verschijnt vervolgens op het kassaticket in WinstonPOS.' },
      { q: 'Wat kost de WinstonPOS-integratie?', a: 'De koppeling is inbegrepen in je Bistroo-abonnement. Controleer bij WinstonPOS of jouw abonnement API-toegang ondersteunt.' },
    ],
  },
}
